<template>
  <div class="page flex-col">
    <div class="main-container">
      <!-- 左侧边栏 -->
      <div class="sidebar">
        <div class="filter-section">
          <div style="display: flex; align-items: center; justify-content: flex-start;">
            <img style="width: 52px; height: 44px; flex-shrink: 0; aspect-ratio: 13/11;"
              src="./assets/img/noun-job-7636302.png" alt="职位管理图标">
            <span class="rcktext">职位管理</span>
          </div>
          <div style="margin-top: 20px;" class="filter-title">筛选条件</div>

          <!-- 职位状态 -->
          <div class="filter-group">
            <div class="group-title">职位状态</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" :value="1" v-model="selectedStatus" @change="handleStatusChange">
                <span>在招</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" :value="2" v-model="selectedStatus" @change="handleStatusChange">
                <span>审核中</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" :value="3" v-model="selectedStatus" @change="handleStatusChange">
                <span>已关闭</span>
              </label>
            </div>
          </div>

          <!-- 发布时间 -->
          <div class="filter-group">
            <div class="group-title">发布时间</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.today" @change="handleFilterChange">
                <span>今天</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.week" @change="handleFilterChange">
                <span>一周内</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.month" @change="handleFilterChange">
                <span>一月内</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.halfYear" @change="handleFilterChange">
                <span>半年内</span>
              </label>
            </div>
          </div>

          <!-- 工作性质 -->
          <div class="filter-group">
            <div class="group-title">工作性质</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="workTypeFilters.intern" @change="handleFilterChange">
                <span>实习生</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="workTypeFilters.partTime" @change="handleFilterChange">
                <span>兼职</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="workTypeFilters.fullTime" @change="handleFilterChange">
                <span>全职</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="content-body">
        
        <div class="top-bar">
          <el-button type="primary" icon="el-icon-plus" @click="openCreateModal"
            style="background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%); border: none;">
            发布职位
          </el-button>
        </div>

        <div class="search-bar">
          <input type="text" class="search-input" placeholder="搜索岗位" v-model="searchQuery"
            @keyup.enter="handleSearch" />
          <div class="search-icon-container" @click="handleSearch">
            <div class="search-icon">
              <img src="./assets/img/search.png" class="search-icon-img" alt="搜索图标" />
            </div>
          </div>
        </div>

        <div class="job-list">
          <div v-if="loading" class="loading-indicator">
            <div class="loading-content">
              <div class="loading-dots">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
              <span class="loading-text">正在加载职位数据...</span>
            </div>
          </div>

          <div v-else-if="jobs.length === 0 && !loading" class="no-data">
            <div class="no-data-content">
              <i class="fa fa-briefcase"></i>
              <span>暂无职位数据</span>
            </div>
          </div>
          
          <template v-else>
            <div v-for="(job, index) in jobs" :key="job.id" 
              class="product-manager-job-card"
              :class="{ 'job-closed': job.status !== 1 }"
              :style="{ animationDelay: `${index * 0.1}s` }"
              @click="handleJobClick(job.id)"
              >
              <div class="job-info-left">
                <span class="job-title">{{ job.title }}</span>
                <div class="job-tags">
                  <template v-if="job.category && job.category.includes('/')">
                    <span class="job-tag" v-for="category in job.category.split('/')" :key="category">{{ category.trim() }}</span>
                  </template>
                  <span class="job-tag" v-else-if="job.category">{{ job.category }}</span>
                  <span class="job-tag" v-show="job.city">{{ job.city }}</span>
                  <span class="job-tag" v-show="job.education">{{ getEducationText(job.education) }}</span>
                  <span class="job-tag" v-show="job.work_nature">{{ job.work_nature }}</span>
                </div>
              </div>
              <div class="job-info-center">
                <div class="candidate-icon">
                  <img src="./assets/img/person.png" alt="候选人图标" />
                </div>
                <span class="candidate-count">{{ job.apply_count || 0 }}人</span>
              </div>
              <div class="job-info-right">
                <el-button type="text" size="small" @click.stop="toggleJobStatus(job.id, job.status)" class="action-button">
                  <i v-if="job.status === 1" class="el-icon-view"></i>
                  <img v-else src="./assets/img/xeye.png" alt="闭眼图标" class="action-icon" />
                  {{ job.status === 1 ? '关闭岗位' : '开放岗位' }}
                </el-button>
                <el-button type="text" size="small" @click.stop="openEditModal(job.id)" class="action-button edit-button" :disabled="job.status !== 1">
                  <i class="el-icon-edit"></i>
                  编辑岗位
                </el-button>
              </div>
            </div>
          </template>
        </div>

        <!-- 无限滚动加载提示 -->
        <div class="infinite-scroll-indicator" v-if="hasMoreData && jobs.length > 0">
          <div v-if="loadingMore" class="loading-more-content">
            <div class="loading-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <span class="loading-text">正在加载更多职位...</span>
          </div>
        </div>


      </div>
    </div>

    <!-- 职位弹窗（发布/编辑） -->
    <EditPositionModal 
      :visible.sync="showPositionModal" 
      :job-id="currentEditJobId" 
      :mode="positionModalMode"
      @refresh="getPositionList" 
    />
    <Profile @changePopup="handlePopupChange" v-if="currentPopup === 'profile'" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getPositionList, getJobInfo, updateJobStatus } from '@/api/position'
import EditPositionModal from './components/EditPositionModal.vue'
import Profile from '@/components/Profile/index.vue';
import { getToken } from '@/store/local/auth'

export default {
  components: {
    EditPositionModal,
    Profile,
  },
  data() {
    return {
      currentPopup: null,
      // 职位数据
      jobs: [],
      loading: false,
      loadingMore: false,
      searchQuery: '',
      totalCount: 0,
      currentPage: 1,
      pageSize: 6,

      // 无限滚动相关
      hasMoreData: true,
      scrollHandler: null,
      scrollThrottle: null,


      // 筛选条件
      selectedStatus: [], // 职位状态单选（使用数组但只允许一个值）
      timeFilters: {
        today: false,
        week: false,
        month: false,
        halfYear: false
      },
      workTypeFilters: {
        intern: false,
        partTime: false,
        fullTime: false
      },

      // 弹窗状态
      showPositionModal: false,
      positionModalMode: 'create', // 'create' 或 'edit'
      currentEditJobId: null
    }
  },

  computed: {
    ...mapState('user', ['avatar'])
  },

  created() {
    // 检查登录状态
    if (!getToken()) {
      this.$message.warning('您尚未登录或登录已过期，请重新登录')
      this.$router.push('/store/entry')
      return
    }

    // 加载职位列表
    this.getPositionList()
  },

  mounted() {
    // 添加滚动监听器
    this.addScrollListener()
  },
  
  beforeDestroy() {
    // 移除滚动监听器
    this.removeScrollListener()
  },
  
  destroyed() {
    // 确保在组件销毁时清理
    this.removeScrollListener()
  },

  methods: {
    handlePopupChange(popupType) {
      this.currentPopup = popupType;
    },
    // 关闭弹窗
    closePopup() {
      this.currentPopup = null;
    },

    handleJobClick(jobId) {
      this.$router.push({ name: 'talent', params: { jobId } })
    },

    // 重置分页状态
    resetPagination() {
      this.jobs = []
      this.currentPage = 1
      this.hasMoreData = true
      this.totalCount = 0
    },

    // 构建请求参数
    buildRequestParams() {
      const params = {
        page_no: this.currentPage,
        page_size: this.pageSize,
        keywords: this.searchQuery || undefined,
      }

      // 处理状态筛选（单选）
      if (this.selectedStatus.length > 0) {
        params.status = this.selectedStatus[0].toString()
      }

      // 处理时间筛选
      if (this.timeFilters.today) params.timeRange = 'today'
      else if (this.timeFilters.week) params.timeRange = 'week'
      else if (this.timeFilters.month) params.timeRange = 'month'
      else if (this.timeFilters.halfYear) params.timeRange = 'halfYear'

      // 处理工作性质筛选
      const workNatureList = []
      if (this.workTypeFilters.intern) workNatureList.push('实习')
      if (this.workTypeFilters.partTime) workNatureList.push('兼职')
      if (this.workTypeFilters.fullTime) workNatureList.push('全职')
      if (workNatureList.length > 0) params.workNature = workNatureList.join(',')

      return params
    },

    // 获取职位列表
    async getPositionList() {
      this.loading = true
      try {
        const params = this.buildRequestParams()
        const response = await getPositionList(params)

        if (response.data.code == 1) {
          const newJobs = response.data.data.lists || []
          // 尝试不同的字段名来获取总数
          const totalCount = response.data.data.total || response.data.data.count || response.data.data.totalCount || newJobs.length
          
          // 重置数据（第一页）
          this.jobs = newJobs
          this.totalCount = totalCount
          this.currentPage = 1
          
          // 判断是否还有更多数据
          this.hasMoreData = this.jobs.length < this.totalCount
        } else {
          this.$message.error('获取职位列表失败: ' + (response.data.message || '未知错误'))
          this.jobs = []
        }
      } catch (error) {
        console.error('获取职位列表异常:', error)
        this.$message.error('获取职位列表失败，请重试')
        this.jobs = []
      } finally {
        this.loading = false
      }
    },

    // 添加滚动监听器
    addScrollListener() {
      this.scrollHandler = this.handleScroll.bind(this)
      
      // 监听window滚动
      window.addEventListener('scroll', this.scrollHandler, { passive: true })
      
      // 也监听content-body容器的滚动
      this.$nextTick(() => {
        const contentBody = document.querySelector('.content-body')
        if (contentBody) {
          contentBody.addEventListener('scroll', this.scrollHandler, { passive: true })
        }
      })
    },

    // 移除滚动监听器
    removeScrollListener() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler)
        
        // 也移除content-body容器的监听器
        const contentBody = document.querySelector('.content-body')
        if (contentBody) {
          contentBody.removeEventListener('scroll', this.scrollHandler)
        }
      }
    },

    // 处理滚动事件
    handleScroll() {
      // 节流处理，避免频繁触发
      if (this.scrollThrottle) return
      
      this.scrollThrottle = setTimeout(() => {
        this.scrollThrottle = null
        this.checkScrollPosition()
      }, 100)
    },

    // 检查滚动位置
    checkScrollPosition() {
      if (this.loadingMore || !this.hasMoreData) return

      // 检查window滚动
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      
      // 检查content-body容器滚动
      const contentBody = document.querySelector('.content-body')
      let containerScrollTop = 0
      let containerHeight = 0
      let containerScrollHeight = 0
      
      if (contentBody) {
        containerScrollTop = contentBody.scrollTop
        containerHeight = contentBody.clientHeight
        containerScrollHeight = contentBody.scrollHeight
      }
      
      // 当滚动到距离底部50px时触发加载
      const shouldLoad = (scrollTop + windowHeight >= documentHeight - 50) || 
                        (containerScrollTop + containerHeight >= containerScrollHeight - 50)
      
      if (shouldLoad) {
        this.loadMore()
      }
    },

    // 加载更多数据
    async loadMore() {
      if (this.loadingMore || !this.hasMoreData) return
      
      try {
        this.loadingMore = true
        // 增加页码
        this.currentPage += 1
        const params = this.buildRequestParams()
        const response = await getPositionList(params)

        if (response.data.code == 1) {
          const newJobs = response.data.data.lists || []
          
          // 追加新数据
          this.jobs = [...this.jobs, ...newJobs]
          
          // 如果总数还是0，但有新数据，说明可能还有更多数据
          if (this.totalCount === 0 && newJobs.length > 0) {
            this.hasMoreData = true
          } else {
            // 根据总数据量判断是否还有更多数据
            this.hasMoreData = this.jobs.length < this.totalCount
          }
        } else {
          // 如果请求失败，回退页码
          this.currentPage -= 1
          this.$message.error('加载更多失败: ' + (response.data.message || '未知错误'))
        }
      } catch (error) {
        // 如果请求失败，回退页码
        this.currentPage -= 1
        console.error('加载更多出错:', error)
        this.$message.error('加载更多失败，请稍后重试')
      } finally {
        this.loadingMore = false
      }
    },

    // 搜索职位
    handleSearch() {
      this.resetPagination()
      this.getPositionList()
    },

    // 筛选条件变化
    handleFilterChange() {
      this.resetPagination()
      this.getPositionList()
    },

    // 处理职位状态单选
    handleStatusChange() {
      // 如果选择了多个，只保留最后一个
      if (this.selectedStatus.length > 1) {
        this.selectedStatus = [this.selectedStatus[this.selectedStatus.length - 1]];
      }
      this.resetPagination()
      this.getPositionList()
    },

    // 查看候选人
    viewCandidates(jobId) {
      this.$router.push({ name: 'talent', params: { jobId } })
    },

    // 打开创建职位弹窗
    openCreateModal() {
      this.positionModalMode = 'create'
      this.currentEditJobId = null
      this.showPositionModal = true
    },

    // 打开编辑职位弹窗
    openEditModal(jobId) {
      this.positionModalMode = 'edit'
      this.currentEditJobId = jobId
      this.showPositionModal = true
    },

    // 切换职位状态
    async toggleJobStatus(jobId, currentStatus) {
      try {
        // 根据当前状态确定新状态
        // 1-在招 -> 3-已关闭
        // 3-已关闭 -> 1-在招
        const newStatus = currentStatus === 1 ? 3 : 1
        
        const response = await updateJobStatus({
          id: jobId,
          status: newStatus
        })      
        
        if (response.data.code === 1) {
          // 更新本地状态
          const job = this.jobs.find(j => j.id === jobId)
          if (job) {
            job.status = newStatus
          }
          
          this.$message.success(newStatus === 1 ? '岗位已开放' : '岗位已关闭')
        } else {
          this.$message.error(response.data.msg || '操作失败，请重试')
        }
      } catch (error) {
        console.error('切换职位状态失败:', error)
        this.$message.error('操作失败，请重试')
      }
    },

    // 将学历数字转换为对应的文本
    getEducationText(educationValue) {
      const educationMap = {
        0: '未知',
        1: '初中',
        2: '高中',
        3: '大专',
        4: '本科',
        5: '硕士',
        6: '博士'
      }
      return educationMap[educationValue] || '未知'
    }

  }
}
</script>
<style scoped lang="css" src="./assets/index.response.css" />
<style scoped lang="css" src="./assets/candidate.css" />
<style scoped lang="scss">
/* 移除页面内头像定位（已全局固定在 App.vue） */
/* 保持原有样式不变 */
.left {
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: linear-gradient(180deg, rgba(177, 110, 249, 0.10) 0%, rgba(126, 180, 235, 0.10) 100%);
  border-radius: 26px;
  border: 1px solid #A47FF6;
  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(27.85px);
  margin-right: -1.5vw;
}

.div42 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-left: 20px;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

.image5 {
  width: 100%;
  height: 60%;
  object-fit: cover;
  border-radius: 25.92px 25.92px 0 0;
}

.frame-1 {
  padding: 20px;
  overflow-y: auto;
  height: calc(100% - 80px);
}

.vector-1 {
  width: 100%;
  height: auto;
}

.div13 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}

.div14 {
  color: #FFFFFF;
  text-align: center;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-decoration: none;
  line-height: 32px;
}

._1 {
  position: absolute;
  width: 13vw;
  min-width: 180px;
  max-width: 300px;
  height: auto;
  top: 3vh;
  left: 0;
  z-index: 0;
}

.sidebar {
  border: none !important;
  border-radius: 0 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  width: 20% !important;
}

.rcktext {
  font-family: Afacad;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  background: var(--linear-2-paints, linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}



.job-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 99%;
  padding: 1vh 2vw;
}

.product-manager-job-card {
  border: 1px solid rgba(177, 110, 249, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  min-height: 80px;
  margin-bottom: 12px;
  box-sizing: border-box;
  background: transparent;
  gap: 20px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: cardFadeIn 0.6s ease forwards;
  opacity: 0;
  overflow: hidden;
  position: relative;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 32px rgba(177, 110, 249, 0.15);
    border-color: rgba(177, 110, 249, 0.4);
  }

  &.job-closed {
    opacity: 0.6;
    filter: grayscale(100%);
    
    .job-title {
      color: #9ca3af;
    }
    
    .job-tag {
      background: rgba(156, 163, 175, 0.1);
      color: #9ca3af;
    }
    
    .candidate-count {
      color: #9ca3af;
      background: #9ca3af;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    .action-button.edit-button {
      color: #9ca3af;
      cursor: not-allowed;
      pointer-events: none;
      
      i {
        color: #9ca3af;
      }
    }
  }

  .job-info-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    flex: 1;
    min-width: 0;
    overflow: hidden;

    .job-title {
      font-size: 18px;
      font-weight: 600;
      color: #1a202c;
      line-height: 1.2;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      letter-spacing: -0.02em;
    }

    .job-tags {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;
      max-width: 100%;
      overflow: hidden;

      .job-tag {
        background: linear-gradient(135deg, rgba(126, 180, 235, 0.1) 0%, rgba(177, 110, 249, 0.1) 100%);
        border: 1px solid transparent;
        padding: 4px 8px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 500;
        color: #4a5568;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 80px;
        transition: all 0.2s ease;
        position: relative;
        
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 12px;
          padding: 1px;
          background: linear-gradient(180deg, #B16EF9 0%, #7EB4EB 100%);
          mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          mask-composite: exclude;
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          z-index: -1;
        }
        
        &:hover {
          background: linear-gradient(135deg, rgba(126, 180, 235, 0.15) 0%, rgba(177, 110, 249, 0.15) 100%);
          transform: translateY(-1px);
        }
      }
    }
  }

  .job-info-center {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 8px;
    width: 120px;
    overflow: hidden;
    justify-self: center;

    .candidate-icon {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      transform: translateY(8px);
      
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .candidate-count {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-weight: 700;
      font-size: 30px;
      line-height: 1;
      letter-spacing: -0.02em;
      background: linear-gradient(135deg, #7EB4EB 0%, #B16EF9 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: center;
      flex-shrink: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
    }
  }

  .job-info-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 6px;
    overflow: hidden;
    justify-self: end;

    .action-button {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-weight: 400;
      font-size: 12px;
      line-height: 1.2;
      letter-spacing: 0.01em;
      text-align: right;
      vertical-align: middle;
      color: #656587;
      text-decoration: none;
      padding: 0;
      margin: 0;
      background: transparent;
      border: none;
      transition: all 0.2s ease;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;

      i {
        font-size: 14px;
        color: #999;
      }

      .action-icon {
        width: 14px;
        height: 14px;
        object-fit: contain;
      }

      &:hover {
        color: #7EB4EB;
        text-decoration: underline;
        
        i {
          color: #7EB4EB;
        }
      }

      &:disabled {
        color: #9ca3af;
        cursor: not-allowed;
        pointer-events: none;
        
        i {
          color: #9ca3af;
        }
      }
    }
  }
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 状态标签样式 */
.status-active {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(22, 163, 74, 0.1) 100%);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #15803d;
  font-weight: 600;
}

.status-inactive {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #dc2626;
  font-weight: 600;
}

/* 搜索框样式 */
.search-bar {
  border-radius: 0 !important;
  width: calc(100% - 4vw) !important;
  margin: 0 2vw 24px 2vw !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center !important;
}

.search-input {
  border-radius: 0 !important;
  border: 1px solid #ddd !important;
  padding: 8px 12px !important;
  font-size: 14px !important;
  outline: none !important;
  width: 100% !important;
  box-sizing: border-box !important;
  margin-left: 0px;
}

.search-input:focus {
  border-color: #7eb4eb !important;
  box-shadow: none !important;
}

.search-icon-container {
  border-radius: 0 !important;
  height: 5vh;
  width: 4vw;
  border-radius: 0rem 1.5vw 1.5vw 0rem;
  border: 1px solid var(--Linear, #B16EF9);
  background: linear-gradient(321deg, rgba(255, 255, 255, 0.00) 2.06%, rgba(255, 255, 255, 0.70) 99.08%);
  margin-left: -3.95vw;
}

.search-icon {
  width: 1.5vw;
  height: 1.5vw;
  color: #999;
  margin-left: 1vw;
  margin-top: -0.5vw;
}

.search-icon-img {
  width: 100%;
  height: 100%;
}

.loading-indicator,
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  height: 100%;
  width: 100%;
  border-radius: 16px;
  margin: 20px 0;
}

.loading-content,
.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeInUp 0.6s ease;
}

.loading-indicator .loading-text,
.no-data span {
  color: #656587;
  font-size: clamp(14px, 1.2vw, 18px);
  font-weight: 500;
  margin-top: 20px;
  letter-spacing: 0.5px;
}

.no-data .fa {
  color: #ddd;
  font-size: 48px;
}

/* 无限滚动指示器样式 */
.infinite-scroll-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(177, 110, 249, 0.05) 100%);
  border-radius: 12px;
  margin: 20px 0;
  transition: all 0.3s ease;
}

.loading-more-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  animation: fadeInUp 0.5s ease;
}

.loading-text {
  color: #656587;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* 加载点动画 */
.loading-dots {
  display: flex;
  gap: 8px;
  align-items: center;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7eb4eb, #b16ef9);
  animation: dotPulse 1.4s ease-in-out infinite both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes dotPulse {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 悬停效果 */
.infinite-scroll-indicator:hover {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(177, 110, 249, 0.08) 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(177, 110, 249, 0.1);
}


/* 响应式设计 */
@media (max-width: 1200px) {
  .product-manager-job-card {
    gap: 24px;
    padding: 20px;
    
    .job-info-center {
      width: 120px;
      padding: 12px;
      align-items: flex-end;
      
      .candidate-count {
        font-size: 24px;
      }
    }
    
    .job-info-right {
      width: 90px;
    }
  }
}

@media (max-width: 768px) {
  .product-manager-job-card {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    text-align: center;
    
    .job-info-left {
      align-items: center;
      text-align: center;
      
      .job-title {
        font-size: 18px;
      }
      
      .job-tags {
        justify-content: center;
      }
    }
    
    .job-info-center {
      width: 100%;
      justify-content: center;
      align-items: flex-end;
      
      .candidate-count {
        font-size: 20px;
      }
    }
    
    .job-info-right {
      width: 100%;
      flex-direction: row;
      justify-content: center;
      gap: 20px;
      
      .action-button {
        width: auto;
        justify-content: center;
      }
    }
  }
}

@media (max-width: 480px) {
  .product-manager-job-card {
    padding: 16px;
    gap: 16px;
    
    .job-info-left {
      .job-title {
        font-size: 16px;
      }
      
      .job-tags {
        gap: 6px;
        
        .job-tag {
          font-size: 12px;
          padding: 4px 8px;
        }
      }
    }
    
    .job-info-center {
      gap: 8px;
      align-items: flex-end;
      
      .candidate-count {
        font-size: 18px;
      }
    }
    
    .job-info-right {
      gap: 12px;
      
      .action-button {
        font-size: 12px;
        gap: 4px;
        
        i {
          font-size: 14px;
        }
      }
    }
  }
}


.page{
  .top-bar{
    justify-content: end;
  }
}

/* 职位状态单选样式 - 只对职位状态筛选组应用 */
.filter-group:first-of-type .checkbox-item input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #B16EF9;
  border-radius: 50%;
  background-color: transparent;
  cursor: pointer;
  position: relative;
  margin-right: 8px;
  transition: all 0.2s ease;
}

.filter-group:first-of-type .checkbox-item input[type="checkbox"]:checked {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  border-color: transparent;
}

.filter-group:first-of-type .checkbox-item input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
}

.filter-group:first-of-type .checkbox-item input[type="checkbox"]:hover {
  border-color: #9C41FF;
  box-shadow: 0 0 0 2px rgba(156, 65, 255, 0.1);
}
</style>